import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import { Form, TextInput, Button, Loading } from 'carbon-components-react';

import MyModal from '../../components/Modal/Modal';
import { addGlobalRegistry, updateGlobalRegistry } from '../../api/global-registries';

const NewGlobalRegistryModal = ({
  mode = "create",
  open = false,
  globalRegistryData,
  refreshList = () => {},
  onClose = () => {},
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);
  const [modalMode, setModalMode] = useState(false);
	// processing is for user initiated component api calls
	const [processing, setProcessing] = useState(false);
  const [globalRegistryInfo, setGlobalRegistryInfo] = useState(null);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");

  const onlyAttachment = localStorage.getItem('only_attachment')

  useEffect(() => setModalMode(mode), [mode]);
  useEffect(() => {
    if(globalRegistryData){
      setGlobalRegistryInfo(globalRegistryData);
      setName(globalRegistryData?.name);
      setUrl(globalRegistryData?.url);
    }
    else{
      setName("");
      setUrl("");
    }
  }, [globalRegistryData]);
  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft: "10px",
  };

  const onChangeName = (input) => {
    setName(input);
  };

  const onChangeUrl = (input) => {
    setUrl(input);
  };

  const saveRegistry = (e) => {
    e.preventDefault();
    
    if (!name) {
      toaster("Please enter name", "warning")
      return;
    }
    
    setProcessing(true);
    if(modalMode === "create"){
      addGlobalRegistry(name, url).then(res => {
        toaster("Global registry created successfully", "success")
        setName("");
        setUrl("")
        onClose();
        refreshList();
        setProcessing(false);
      }).catch(error => {
        toaster("Failed to create new Global Registry", "error")
        setProcessing(false);
      });
    } else{
      updateGlobalRegistry(globalRegistryInfo.id, {name:name, url:url}).then(res =>{
        toaster("Global Registry updated successfully", "success")
        onClose();
        refreshList();
        setProcessing(false);
      }).catch(error => {
        toaster("Failed to update global registry", "error")
        setProcessing(false);
      });;
    };
  }

  
	const additionalProps = {
		className: 'some-class',
		onSubmit: saveRegistry
	};
  
  return (
    <MyModal
      modalHeading="Global Registry Details"
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <ModalContent>

      {
					processing || loading ? 
					<Loading/> 
					:
					<></>
				}
				
				<Form {...additionalProps}>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              value={name}
              labelText="Global Registry Name*"
              // placeholder="Please enter Global Registry Name"
              onChange={e => onChangeName(e.target.value)}
              required
            />
          </div>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              value={url}
              labelText="Global Registry Url"
              // placeholder="Please enter Global Registry Url"
              onChange={e => onChangeUrl(e.target.value)}
            />
          </div>

          <ModalFooter>

          <Button 
              kind="secondary"
              onClick={onClose}
              style={addBtnStyle}  
            >Cancel</Button>

            <Button
              type="submit"
              kind="primary"
              // onClick={() => onCreate()}
              style={addBtnStyle}  
              disabled={onlyAttachment === "true"}
            >{ (modalMode === "create") ? "Create Global Registry" : "Update Global Registry" }</Button>
          </ModalFooter>

        </Form>

      </ModalContent>
    </MyModal>
  );
};

export default NewGlobalRegistryModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
